import { Text, Tooltip } from "@wix/design-system";
import classNames from "classnames";
import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import {
  LIST_ITEM_SELECT,
  LIST_ITEM_SELECT_PREFIX,
  LIST_ITEM_SELECT_SUBTITLE,
  LIST_ITEM_SELECT_SUFFIX,
  LIST_ITEM_SELECT_TITLE
} from "./data-hooks.js";
import classes from "./list-item-select-scss.js";
const ListItemSelect = ({
  title,
  subtitle,
  prefix,
  suffix,
  dataHook,
  selected = false,
  disabled = false,
  onSelect,
  className,
  tooltip,
  ...props
}) => {
  const { isMobile } = useContext(RicosContext);
  const listItemSelect = /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(classes.root, className, {
        [classes.selected]: selected,
        [classes.disabled]: disabled,
        [classes.mobile]: isMobile,
        [classes.withSubtitle]: !!subtitle
      }),
      "data-hook": classNames(LIST_ITEM_SELECT, dataHook),
      role: "option",
      "aria-selected": selected,
      "aria-disabled": disabled,
      tabIndex: disabled ? -1 : 0,
      onClick: (e) => {
        if (disabled) {
          return;
        }
        e.stopPropagation();
        onSelect?.(e);
      },
      onKeyDown: (e) => {
        if (disabled) {
          return;
        }
        if (e.key === "Enter" || e.key === " ") {
          e.stopPropagation();
          e.preventDefault();
          onSelect?.(e);
        }
      },
      ...props
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames(classes.content, {
          [classes.withSubtitle]: !!subtitle
        })
      },
      prefix && /* @__PURE__ */ React.createElement("div", { className: classes.prefix, "data-hook": LIST_ITEM_SELECT_PREFIX }, prefix),
      title && /* @__PURE__ */ React.createElement(
        Text,
        {
          size: isMobile ? "medium" : "small",
          className: classes.title,
          skin: disabled ? "disabled" : "standard",
          dataHook: LIST_ITEM_SELECT_TITLE
        },
        title
      ),
      subtitle && /* @__PURE__ */ React.createElement(
        Text,
        {
          size: isMobile ? "small" : "tiny",
          secondary: true,
          className: classes.subtitle,
          skin: disabled ? "disabled" : "standard",
          dataHook: LIST_ITEM_SELECT_SUBTITLE
        },
        subtitle
      ),
      suffix && /* @__PURE__ */ React.createElement("div", { className: classes.suffix, "data-hook": LIST_ITEM_SELECT_SUFFIX }, suffix)
    )
  );
  return tooltip ? /* @__PURE__ */ React.createElement(Tooltip, { content: tooltip, size: "small", moveBy: { y: 8 } }, listItemSelect) : listItemSelect;
};
export {
  ListItemSelect
};
//# sourceMappingURL=list-item-select.js.map
